// The backend attributes changes made by the system (not a real user) to the
// nil UUID. We surface these as a "System" author in the version history.
export const SYSTEM_AUTHOR_ID = '00000000-0000-0000-0000-000000000000'
export const SYSTEM_AUTHOR_LABEL = 'System'
